import React, { useEffect, useState } from "react";
import { DiscountRow, Product, Variant } from "../../types.ts";
import InfoIcon from "../../../../../assets/images/icon-info.svg";
import Dialog from "../Common/Dialog.tsx";

import { styled } from 'styled-components';
import { bp, size } from "../../../../../styles/breakPoints.tsx";
import { ProductCardVisibility } from "../../../../types.ts";

import { getPeriodNumberFromLabel } from "../../../../../misc/helpers.ts";
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";

interface ProductcardMode {
  direction: 'vertical' | 'horizontal'
  color?: string;
  $ecological: string;
}

const B2BProductCardContainer = styled.div<ProductcardMode>`
  border-radius: 8px;
  border: ${(props) => '2px solid ' + (props.$ecological === 'true' ? '#4C7C04' : '#004107')};
  background: var(--Valo);
  min-width: 310px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .main {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: content-box;
    height: 100%;

    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;

      @media ${bp.lg} {
        flex-direction: ${props => props.direction === 'vertical' ? 'column' : 'row'};
      }
    }
  }

  ul {
    padding-inline-start: 20px;
  }

  .left {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;

    @media ${bp.lg} {
      width: ${props => props.direction === 'vertical' ? 'auto' : '600px'};
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    justify-content: space-between;
    position: relative;

    @media ${bp.lg} {
      width: ${props => props.direction === 'vertical' ? 'auto' : 'calc(100% - 600px)'};
    }
  }

  .title {
    color: var(--Varjo);
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    font-family: itc-benguiat,serif;
  }

  .variants {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    .variant {
      border-radius: 50px;
      display: inline-block;
      padding: 0 8px;
      background: var(--Valkoinen, #fff);
      border: 2px solid var(--Lumme, #004107);
      color: var(--Lumme);
      font-weight: 700;
      line-height: 2;
      margin-bottom: 0;

      &:focus-within {
        outline: 2px solid var(--Lumme, #004107);
      }
    }

    input[type="radio"] {
      background-color: var(--Valkoinen, #fff);
      appearance: none;
      opacity: 0;
      position: absolute;
      height: 6px;
      width: 6px;
      top: 3px;
      border-color: var(--Valkoinen, #fff);
      box-shadow: none;
    }

    input[type="radio"]:checked {
      background-color: var(--Lumme, #004107);
    }

    input[type="radio"]::before {
      width: 6px;
      height: 6px;
      background-color: var(--Valkoinen, #fff);
    }

    input[type="radio"]:checked:before {
      width: 6px;
      height: 6px;
      background-color: var(--Lumme, #004107);
    }

    .selected {
      background: var(--Lumme, #004107);
      color: var(--Valkoinen, #fff);
    }
  }

  .tags {

    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .tag {
      background: #E6EBED;
      border-radius: 50px;
      display: inline-block;
      list-style: none;
      padding: 6px 16px;
      display: flex;
      align-items: center;
      gap: 6px;

      img {
        height: 22px;
      }
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;

    a {
      color: var(--Varjo, #1D1D1D);
      font-family: var(--font-family);
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      text-decoration-line: underline;
      width: fit-content;
      display: flex;
      justify-content: center;

      &.link-button {
        width: 100%;
        background-color: transparent;
        border: none;
      }
    }

    button {
      width: 100%;
    }
  }

  .price-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    display: inline;
  }

  .forecast {
    color: var(--Varjo);
    font-family: itc-benguiat,serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
  }

  .price-main {
    font-family: itc-benguiat,serif;
    border-radius: 6px;
    background: var(--b2b-Lime,#E6F499);
    display: inline-flex;
    padding: 8px;
    color: var(--Varjo);
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;

    .big {
      font-size: 32px;
      font-weight: 700;
      line-height: 32px;
    }
  }
  .price-contains {
    border-top: ${(props) => '2px solid ' + (props.$ecological === 'true' ? '#4C7C04' : '#004107')};
    margin: 20px 0;
    color: var(--Varjo);
    font-family: var(--font-family);
    font-size: 12px;
    font-weight: normal;
    font-weight: 500;

    .price-note-title {
      font-weight: 700;
      padding: 20px 0 10px;
    }
  }


  .terms-text {
    padding: 12px 16px;
    background: ${(props) => props.$ecological === 'true' ? '#E6F499' : '#E6EBED'};
    display: flex;
    border-radius: 0 0 10px 10px;
    gap: 10px;
    align-items: center;

    a {
      color: var(--Varjo);
      font-family: var(--font-family);
      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
      text-decoration-line: underline;
    }

    button {
      background: transparent;
      border: none;
      color: var(--Varjo);
      font-family: var(--font-family);
      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
      text-decoration-line: underline;
      padding: 0;
    }
  }

  .campaign-text {
    margin-top: 20px;
    padding-left: 30px;
    position: relative;
    color: var(--Lumme, #004107);

    &::before {
      content: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.95723 4.69988C2.95723 4.23796 3.14073 3.79496 3.46736 3.46833C3.79398 3.14171 4.23698 2.95821 4.6989 2.95821H5.49057C5.95045 2.95795 6.39155 2.77581 6.71765 2.45154L7.27182 1.89738C7.43367 1.73461 7.6261 1.60544 7.83805 1.5173C8.05 1.42916 8.27728 1.38379 8.50682 1.38379C8.73636 1.38379 8.96364 1.42916 9.17558 1.5173C9.38753 1.60544 9.57996 1.73461 9.74182 1.89738L10.296 2.45154C10.6222 2.77613 11.0639 2.95821 11.5231 2.95821H12.3147C12.7767 2.95821 13.2197 3.14171 13.5463 3.46833C13.8729 3.79496 14.0564 4.23796 14.0564 4.69988V5.49154C14.0564 5.95071 14.2385 6.39246 14.5631 6.71863L15.1172 7.27279C15.28 7.43465 15.4092 7.62708 15.4973 7.83903C15.5854 8.05097 15.6308 8.27825 15.6308 8.50779C15.6308 8.73734 15.5854 8.96461 15.4973 9.17656C15.4092 9.38851 15.28 9.58094 15.1172 9.74279L14.5631 10.297C14.2388 10.6231 14.0567 11.0642 14.0564 11.524V12.3157C14.0564 12.7776 13.8729 13.2206 13.5463 13.5473C13.2197 13.8739 12.7767 14.0574 12.3147 14.0574H11.5231C11.0632 14.0576 10.6221 14.2398 10.296 14.564L9.74182 15.1182C9.57996 15.281 9.38753 15.4101 9.17558 15.4983C8.96364 15.5864 8.73636 15.6318 8.50682 15.6318C8.27728 15.6318 8.05 15.5864 7.83805 15.4983C7.6261 15.4101 7.43367 15.281 7.27182 15.1182L6.71765 14.564C6.39155 14.2398 5.95045 14.0576 5.49057 14.0574H4.6989C4.23698 14.0574 3.79398 13.8739 3.46736 13.5473C3.14073 13.2206 2.95723 12.7776 2.95723 12.3157V11.524C2.95697 11.0642 2.77484 10.6231 2.45057 10.297L1.8964 9.74279C1.73363 9.58094 1.60447 9.38851 1.51633 9.17656C1.42819 8.96461 1.38281 8.73734 1.38281 8.50779C1.38281 8.27825 1.42819 8.05097 1.51633 7.83903C1.60447 7.62708 1.73363 7.43465 1.8964 7.27279L2.45057 6.71863C2.77484 6.39253 2.95697 5.95142 2.95723 5.49154V4.69988Z' fill='%23004107'/%3E%3Cpath d='M6.125 8.49984L7.70833 10.0832L10.875 6.9165' fill='%23004107'/%3E%3Cpath d='M6.125 8.49984L7.70833 10.0832L10.875 6.9165' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      position: absolute;
      top: 0.5rem;
      left: 0;
    }
  }

  .vat-note {
    font-size: 14px;
  }

`;

interface ProductCardProps {
  product: Product;
  horizontal?: boolean;
  actionButtonText?: string;
  buttonLink?: string;
  variantLink?: boolean;
  visibility?: ProductCardVisibility;
  preSelectedVariantId?: string;
  discountRows: DiscountRow[];
  onClick: (variant: Variant) => void;
}

function ProductCard({ product, horizontal, actionButtonText, visibility, buttonLink, variantLink, preSelectedVariantId, discountRows,  onClick }: ProductCardProps) {
  const { t, db_t, i18n } = useAppTranslation();
  const [currentLanguage] = useState(i18n.language);

  const [availableVariants] = useState(product.variants.filter(variant => variant.is_available === 1 && variant.is_hidden === 0));

  const [selectedVariant, setSelectedVariant] = useState(
    availableVariants.find(variant => variant.contract_template_id === preSelectedVariantId) ?? product.variants.filter(variant => variant.is_available === 1 && variant.is_hidden === 0)[0]
  );

  const [tags] = useState(product.tags?.filter(tag => tag.is_visible === 1));
  const [dialogVisible, setDialogVisible] = useState(false);
  const [isEcological] = useState(!!product.tags.find(tag => tag.name === 'Ekologinen'));

  const [discountRow, setDiscountRow] = useState<DiscountRow | undefined>(undefined);
  const [contractPeriod, setContractPeriod] = useState<number | undefined>(getPeriodNumberFromLabel(selectedVariant.contract_period.label));

  const handleVariantClick = (variant: Variant) => {
    setSelectedVariant(variant);
  }

  const handleClick = () => {
    onClick(selectedVariant);
  }

  const priceMarginSynergia = '0,25';
  const priceMarginSynergiaGreen = '0,95';

  // This can be removed when the date is reached
  // fingridCost should be 0,173 before datetime 1.6.2025 00:00(utc + 3) and 0,166 after that
  let fingridCost = '0,173';
  const currentDate = new Date();
  const changeDate = new Date('2025-06-01T00:00:00+03:00');// 1.6.2025 00:00 (UTC +3)
  if (currentDate >= changeDate) {
    fingridCost = '0,166';
  }

  const [windowHeight, setWindowHeight] = useState(0);
  const [alternativeVariantPosition, setAlternativeVariantPosition] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight - 200);
      setAlternativeVariantPosition((window.innerWidth > size.lg) && horizontal == true);
    };

    window.addEventListener('resize', handleResize);

    // send resize event on initial load
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    setAlternativeVariantPosition((window.innerWidth > size.lg) && horizontal == true);
  }, [horizontal]);

  useEffect(() => {
    setDiscountRow(discountRows.find(row => row.productId === selectedVariant.hs_id));
    setContractPeriod(getPeriodNumberFromLabel(selectedVariant.contract_period.label));
  }, [selectedVariant]);

  return (
    <>
      <B2BProductCardContainer
        direction={horizontal ? 'horizontal' : 'vertical'}
        $ecological={isEcological ? 'true' : 'false'}
        key={product.hs_id}>

        <div className="main">
          <div className="content">
            <div className="left">
              <div className="title"> {db_t(product, 'name')}</div>

              {!alternativeVariantPosition && <div className="variants">
                {availableVariants.map((variation) => (
                  <label key={variation.hs_id} className={'variant' + (selectedVariant.contract_template_id === variation.contract_template_id ? ' selected' : '')}>
                    <input
                      type="radio"
                      name={"variant" + product.hs_id + (horizontal ? 'horizontal' : '')}
                      value={variation.contract_template_id}
                      checked={selectedVariant.contract_template_id === variation.contract_template_id}
                      onChange={() => handleVariantClick(variation)}
                    />
                    <span>{t('common.' + variation.contract_period.label)}</span>
                  </label>
                ))}
              </div>}

              {tags.length > 0 && <div className="tags">
                {tags.map((tag) => (
                  <div className="tag" key={tag.hs_id}>
                    {tag.icon && <img src={tag.icon.url} alt={tag.icon.altText} />}
                    <span>{db_t(tag, 'name')}</span>
                  </div>
                ))}
              </div>}

              {visibility?.show_description != false && <div className="description" dangerouslySetInnerHTML={{ __html: db_t(selectedVariant, 'description') }}></div>}
            </div>

            <div className="right">
              {visibility?.show_prices != false && <div>
                {alternativeVariantPosition && <div className="variants">
                  {availableVariants.map((variation) => (
                    <label key={variation.hs_id} className={'variant' + (selectedVariant.contract_template_id === variation.contract_template_id ? ' selected' : '')}>
                      <input
                        type="radio"
                        name={"variant" + product.hs_id + (horizontal ? 'horizontal' : '')}
                        value={variation.contract_template_id}
                        checked={selectedVariant.contract_template_id === variation.contract_template_id}
                        onChange={() => handleVariantClick(variation)}
                      />
                      <span>{t('common.' + variation.contract_period.label)}</span>
                    </label>
                  ))}
                </div>}
                <div className="price-content">
                  {selectedVariant.name.includes('Synergia') && <div className="forecast">{t('common.priceForecast')}</div>}
                  <div className="price-main">
                    {selectedVariant.name.includes('Pörssisähkö') && <div>
                      <span className="big">SPOT</span> + {selectedVariant.energy_price.toLocaleString('fi-FI')} {t('common.c/kWh')}
                    </div>}
                    {!selectedVariant.name.includes('Pörssisähkö') && <div>
                      <span className="big">{selectedVariant.energy_price.toLocaleString('fi-FI')} </span>{t('common.c/kWh')}
                    </div>}
                  </div>
                </div>
                <div>
                  {selectedVariant.name.includes('Jousto') && <div>+/- {t('common.consumptionImpact')}</div>}
                  {/* <div>{t('common.monthlyPrice')}: <b>{selectedVariant.monthly_price.toLocaleString('fi-FI')} {t('common.€/month')}</b></div> */}
                  <div>{t('common.monthlyPrice')}: <b>{(discountRow && (contractPeriod == null || discountRow.duration <= contractPeriod)) ? '0' : selectedVariant.monthly_price.toLocaleString('fi-FI') } {t('common.€/month')}</b></div>
                  {(discountRow && selectedVariant.monthly_price > 0) && <div>({(contractPeriod == null || discountRow.duration < contractPeriod) ? t('phaseTwo.firstMonths', {duration: discountRow.duration}) : ''}{t('common.normally')} {selectedVariant.monthly_price.toLocaleString('fi-FI')}{t('common.€/month')})</div>}
                  <div className="vat-note">{t('common.vatFree')}</div>
                </div>
                {visibility?.show_campaign != false && selectedVariant.campaign_text && <div className="campaign-text" dangerouslySetInnerHTML={{ __html: selectedVariant.campaign_text }}></div>}

                {selectedVariant.name.includes('Synergia') && <div className="price-contains">
                  <div className="price-note-title">{t('phaseTwo.priceContains')}</div>
                  <div>{t('phaseTwo.fixedPriceMargin', {price: isEcological ? priceMarginSynergiaGreen : priceMarginSynergia})}</div>
                  <div>+/- {t('common.consumptionImpact')}</div>
                  <div>{t('phaseTwo.consumptionPrice', { cost: fingridCost })}</div>
                </div>}
              </div>}

              <div className="actions">
                {visibility?.show_cta_button != false && <> {buttonLink
                  ? <a href={!variantLink ? buttonLink : `${buttonLink}?contract=${selectedVariant.contract_template_id}&type=yritykset${currentLanguage === 'en' ? '&lang=en' : ''}`} className="link-button"><button type="button" className="lumme-button lumme" onClick={handleClick}>{actionButtonText ? actionButtonText : 'Tilaa'}</button></a>
                  : <button type="button" className="lumme-button lumme" onClick={handleClick}>{actionButtonText ? actionButtonText : t('phaseTwo.cta')}</button>}
                </>}
                {visibility?.show_product_page_link != false && <a href={selectedVariant.product_page_link} target="_blank" rel="noreferrer">{t('phaseTwo.readMore')}</a>}
              </div>
            </div>
          </div>
        </div>

        <div className="terms-text">
          <img src={InfoIcon} />
          {(!!selectedVariant.popup_content || !!selectedVariant.popup_pdf_url)
            ? <a href="#"><button type="button" className="link-button black" onClick={() => setDialogVisible(true)}>{t('phaseTwo.termsAndPrices')}</button></a>
            : <a href={"https://www.lumme-energia.fi/sahkosopimus/sopimusehdot"} target="_blank" rel="noreferrer">{t('phaseTwo.termsAndPrices')}</a>
          }
        </div>

      </B2BProductCardContainer>
      <Dialog isVisible={dialogVisible} onClose={() => setDialogVisible(false)}>
        {selectedVariant.popup_content && !selectedVariant.popup_pdf_url && <div dangerouslySetInnerHTML={{ __html: selectedVariant.popup_content }}></div>}
        {selectedVariant.popup_pdf_url &&
          <iframe src={selectedVariant.popup_pdf_url} width={'100%'} height={windowHeight}></iframe>
        }
      </Dialog>
    </>
  )
}

export default ProductCard;
